import React, { Component } from 'react';
import "./RenderPins.scss";
import pinsJson from "../../static/api/data.json";
import { pins } from "../App/filters"

export default class RenderPins extends Component {
  constructor() {
    super();
    this.state = {}
  }
  renderPins = () => {
    // .filter(key => {
    //   if (this.props.currentFilter != "") {
    //     return key.Filter.indexOf(this.props.currentFilter) > -1
    //   }
    //   return key;
    // })
    return pinsJson.map((item, index) => <div
      onClick={() => {
        this.props.togglePopup({
          ...item,
          index: index
        });
      }}
      key={index} className={`pinned ${this.props.currentFilter == "" ? "show" : item.Filter.indexOf(this.props.currentFilter) > -1 ? "show" : "hide"} pin-${index}`}>
      <div className={`_pin pt-${this.props.currentFilter != "" ? pins.filter(key => key.filter == this.props.currentFilter)[0].image : (() => {
        let firstFilter = item.Filter.split(",");
        let random = Math.floor((Math.random() * firstFilter.length) + 0);
        return pins.filter(key => key.filter.indexOf(firstFilter[random]))[random].image
      })()}`}></div>
    </div >)
  }
  render() {
    return (
      <section className="section section-pins"
        onClick={(event) => {
          if (event.target.className.indexOf("_pin") == -1) {
            this.props.togglePopup(null);
          }
        }}>
        {this.renderPins()}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/RenderPins/RenderPins.jsx